/** Shared copy for `AllDayEventChip`. Split out so the component file only
 *  exports components (react-refresh). */

/**
 * Last resort only. The chip and the grey-day tooltip both show the calendar's
 * own words; this covers an event the provider sent with no title at all.
 */
export const ALL_DAY_EVENT_FALLBACK_TITLE = 'All-day event';
